import * as React from 'react';
import { styled } from 'styled-components';
import { BbocResult } from '../../../../../core/bbocResultData';
import { desktopMinWidth, slateGrey, superLightGreyColour, tabletPortraitMinWidth } from '../../../../cssConstants';

const BarChunk = ({ score, bbocResult }: BarItemProps) => {
	const { range, title } = bbocResult;
	const isActive = getActiveStatus(score, bbocResult);
	return (
		<Container>
			<Bar className="bar" $active={isActive} />
			<BarLabel $active={isActive}>{title}</BarLabel>
			<BarRange $active={isActive}>{range}</BarRange>
		</Container>
	);
};

export default BarChunk;

interface BarItemProps {
	score: number | null;
	bbocResult: BbocResult;
}

export const getActiveStatus = (score: number | null, bbocResult: BbocResult) => {
	if (!score) return false;

	const { min, max } = bbocResult;
	return score >= min && score <= max;
};

const Container = styled.div`
	display: inline-flex;
	flex-direction: column;
	width: calc((100% - 16px) / 5);
	margin-right: 4px;

	&:first-child .bar {
		border-radius: 5px 0 0 5px;
	}

	&:last-child {
		margin-right: 0;

		> .bar {
			border-radius: 0 5px 5px 0;
		}
	}
`;

const Bar = styled.div<{ $active: boolean }>`
	height: 10px;
	background-color: ${(props) => (props.$active ? props.theme.progressColour : '#e5e7eb')};
`;

const BarLabel = styled.p<{ $active: boolean }>`
	color: ${(props) => (props.$active ? props.theme.progressColour : superLightGreyColour)};
	font-size: 8px;
	font-weight: 500;
	line-height: 10px;
	margin-top: 3px;

	@media (min-width: ${tabletPortraitMinWidth}) {
		font-size: 10px;
		line-height: 14px;
		margin-top: 5px;
	}

	@media (min-width: ${desktopMinWidth}) {
		font-size: 14px;
		line-height: 19px;
		margin-top: 10px;
	}
`;

const BarRange = styled.p<{ $active: boolean }>`
	color: ${(props) => (props.$active ? props.theme.progressColour : slateGrey)};
	font-size: 9px;
	font-weight: 500;
	line-height: 11px;
	margin-top: 3px;

	@media (min-width: ${tabletPortraitMinWidth}) {
		font-size: 10px;
		line-height: 14px;
		margin-top: 5px;
	}

	@media (min-width: ${desktopMinWidth}) {
		font-size: 14px;
		line-height: 19px;
		margin-top: 10px;
	}
`;
